"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Constants = require("../../Constants");

var SVGBase = function SVGBase(props) {
  var __isHasMore = props._isHasMore,
      __isListReversed = props._isListReversed,
      __src = props.src,
      __styledJunk0 = props['0'],
      __styledJunk1 = props['1'],
      rest = (0, _objectWithoutProperties2.default)(props, ["_isHasMore", "_isListReversed", "src", "0", "1"]);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest));
};

SVGBase.propTypes = {
  size: _react.PropTypes.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  _isHasMore: _react.PropTypes.bool,
  _isListReversed: _react.PropTypes.bool,
  '0': _react.PropTypes.any,
  '1': _react.PropTypes.any,
  src: _react.PropTypes.string
};
var _default = SVGBase;
exports.default = _default;
module.exports = exports.default;